import React from "react";
import useSaleModeStore from "../../store/sale-mode-store";

type TProps = {
  forceDisable?: boolean;
  FallBack?: JSX.Element;

  variant?: "pricing" | "review" | "permotion";
};

const ActiveSaleBanner: React.FC<TProps> = ({
  forceDisable,
  FallBack = null,
  variant = "permotion",
}) => {
  const saleMode = useSaleModeStore((state) => state.saleMode);
  const noSaleModeBanner = useSaleModeStore((state) => state.noSaleModeBanner);
  const storeBanners = useSaleModeStore((state) => state.saleBanners);

  const selectedBanners = storeBanners;

  let BannerComponent = null;

  if (variant === "pricing") {
    BannerComponent =
      selectedBanners?.pricingBanner ?? selectedBanners?.promotionBanner;
  } else if (variant === "review") {
    BannerComponent =
      selectedBanners?.reviewBanner ?? selectedBanners?.promotionBanner;
  } else {
    BannerComponent = selectedBanners?.promotionBanner;
  }

  // Guard conditions
  if (!saleMode || saleMode === "NONE") return FallBack;
  if (forceDisable) return FallBack;
  if (noSaleModeBanner) return FallBack;
  if (!BannerComponent) return FallBack;

  return BannerComponent;
};

export default ActiveSaleBanner;
